export function safe<TResult>(action: () => TResult, defaultResult?): TResult {
	try {
		return action() || defaultResult;
	} catch (e) {
		if (e.name === "TypeError" || e.name === "ReferenceError") {
			return defaultResult;
		}

		throw e;
	}
}

export function limit<TResult>(func: (...args: any[]) => any, limit: number): (...args: any[]) => void {
	let closureFn = () => {
		let timeoutId: number;

		return (...args: any[]) => {
			if (timeoutId) {
				clearTimeout(timeoutId);
			}

			timeoutId = window.setTimeout(() => func(args), limit);
		};
	};

	return closureFn();
}

/**
 *  Combines the styles in the internal stylesheet with the styles in the external
 *  one, adding external rules if they do not exist in the internal sheet
 *
 *  @param {Object} internalStyles - The component's internal styles
 *  @param {Object} externalStyles - The styles to override with
 */

export function overrideCSS(internalStyles: Object, externalStyles: Object): Object {
	let newCSS = {};

	for (let entry in internalStyles) {
			if (Object.keys(externalStyles).indexOf(entry) != -1) {
				newCSS[entry] = `${internalStyles[entry]} ${externalStyles[entry]}`;
			}else{
				newCSS[entry] = internalStyles[entry];
			}
	}

	return newCSS;
}


// WEBPACK FOOTER //
// ./src/client/utils/function.ts